<template lang="">
  <section id="subVisual" class="subVis2">
    <div>
      <h2>Company</h2>
      <p>
        온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
        제공하겠습니다.
      </p>
    </div>
  </section>
  <main id="cont" class="comCon">
    <div id="comp">
      <article class="greeting">
        <v-img src="@/assets/img/common/img_comp1.jpg" alt="" />
        <div class="txt">
          <h3>
            더 나은 미래를 향해 앞서가는 <br /><strong
              >기술력과 노하우로 보답</strong
            >하겠습니다.
          </h3>
          <p>
            안녕하세요. 좋은 세상을 함께 만들어 가고픈 온크루소프트(주) 대표
            신윤성 입니다.<br class="br" />온크루소프트 기업이념은 고객과 함께
            성장하는 회사입니다. <br />2009년에 창업을 시작으로 IT 분야에서
            풍부한 경험과 전문성을 바탕으로 <br />고객사와 함께 성장해가고
            있습니다. 더불어 급변하는 IT 시장에서의 기술환경 강화에
            <br />능동적으로 대처하고 있습니다. 고객에게 한발더 다가가기 위하여
            새로운 패더라임과 <br />IT 환경에서의 이해를 통해 축적된 노하우와
            기술력으로, 최고의 솔루션과 서비스를 <br />제공하기위한 노력을 통해
            신뢰받는 온크루소프트(주)가 될 것을 약속 드립니다.<br
              class="br"
            />끊임없는 변화와 도전을 지켜봐주시고 응원해 주십시오.
          </p>
          <div class="ceo">
            <strong>과거의 배움과 현재의 최선, 미래를 준비하는</strong>
            <p>온크루소프트(주) 대표이사</p>
            <v-img
              src="@/assets/img/common/sign.png"
              alt="신윤성"
              cover
              width="70px"
              aspect-ratio="70/33"
            />
          </div>
        </div>
      </article>

      <article class="about inner_box">
        <h3 class="comp_tit">
          IT 솔루션 전문기업 <span>온크루소프트 입니다.</span>
        </h3>
        <v-img
          src="@/assets/img/common/img_comp2.jpg"
          alt=""
          style="width: 1000px; height: 450px; margin: 0 auto"
        />
        <!--p>당사는 보안(DB, Network 통합, Application), WAN 가속기 전문 회사로서 오랜 기간 고객과 호흡을 같이 하며 성장 해 왔으며, 변화하는 시대에 맞춰 융.복합 솔루션(Versa Network), <br />해커 침입에 대한 탐지 및 차단 등 차세대를 준비하는 고객의 요구사항에 맞는 최상의 서비스와 기술력을 제공해 드릴 것을 약속 합니다.</p-->
        <p>
          당사는 기업 외부 환경인 소셜 미디어 및 디지털 환경에서 일어날 수
          저작권 침해, 브랜드 사칭, 이미테이션 판매와 같은 기업 및 브랜드에
          악영향을 미치는 위험으로부터 <br />기업 및 브랜드를 보호하는 플랫폼을
          제공하고 있습니다. <br class="br" />또한 DB 암호화 및 암호화 키 관리와
          같은 기업 내부 보안을 위한 솔루션 및 시스템 운영 • 배치 작업 자동화
          솔루션도 제공하고 있습니다. <br class="br" />기업자산 보호는 물론
          관리, 운영까지 고객의 요구사항에 맞는 최상의 서비스와 기술력을 제공해
          드릴 준비가 되어있습니다.
        </p>
      </article>

      <article class="organ inner_box">
        <h3 class="comp_tit">조직도</h3>

        <p class="ceo">대표이사</p>
        <div class="clearfix">
          <ul>
            <li class="team">경영 지원팀</li>
            <li>총무/인사</li>
          </ul>
          <ul>
            <li class="team">영업팀</li>
            <li>솔루션 영업</li>
          </ul>
          <ul>
            <li class="team">기술 지원팀</li>
            <li>솔루션 지원</li>
            <li>컨설팅</li>
          </ul>
        </div>
      </article>

      <article class="loca inner_box">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.030127716698!2d126.89591131531056!3d37.53078707980468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9ee829dcbc17%3A0xd102faffc1e55fca!2z7ISc7Jq47Yq567OE7IucIOyYgeuTse2PrOq1rCDri7nsgrAy64-ZIOuLueyCsOuhnDQx6ri4IDEx!5e0!3m2!1sko!2skr!4v1567673591698!5m2!1sko!2skr"
          width="100%"
          height="474"
          frameborder="0"
          style="border: 0"
          allowfullscreen=""
        ></iframe>
        <div class="mapCon">
          <dl>
            <dt>주소</dt>
            <dd>서울특별시 영등포구 당산로 41길 11 <br />SKV1센터 W동 809호</dd>
          </dl>
          <dl>
            <dt>TEL</dt>
            <dd>02-6450-0851</dd>
          </dl>
        </div>
      </article>
    </div>
  </main>
</template>
<script>
export default {};
</script>
<style></style>
